import { Button } from "@mui/material";
import PropTypes from "prop-types";
import LoadingSpinner from "./loading-spinner";

const CustomButton = ({
  buttonType = "fill",
  fillDark = false,
  disabled = false,
  label = "",
  onClick = () => {},
  onKeyPress = () => {},
  isLoading = false,
  href = "",
  size = "medium",
  style = {},
}) => {
  return (
    <Button
      disabled={disabled}
      target="_blank"
      className={`custom-button-${buttonType}${fillDark ? "-dark" : ""}`}
      href={href}
      onClick={onClick}
      size={size}
      onKeyDown={onKeyPress}
      style={style}
    >
      {isLoading ? <LoadingSpinner /> : label}
    </Button>
  );
};

const CustomButtonOutLine = ({
  label = "",
  onClick = () => {},
  onKeyPress = () => {},
  href = "",
  disabled = false,
  isLoading = false,
  buttonType = "dark",
  size = "medium",
  icon = null,
}) => {
  return (
    <Button
      disabled={disabled}
      target="_blank"
      className={`custom-button-${buttonType}`}
      href={href}
      size={size}
      onClick={onClick}
      onKeyDown={onKeyPress}
    >
      {isLoading ? <LoadingSpinner /> : label}
      {icon && <div className="plus-icon">{icon}</div>}
    </Button>
  );
};

CustomButton.propTypes = {
  label: PropTypes.string,
  onClick: PropTypes.func,
  onKeyPress: PropTypes.func,
};

CustomButtonOutLine.propTypes = {
  label: PropTypes.string,
  onClick: PropTypes.func,
  onKeyPress: PropTypes.func,
};

export { CustomButtonOutLine };
export default CustomButton;
